/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PerformerMedia } from './PerformerMedia';
import {
    PerformerMediaFromJSON,
    PerformerMediaFromJSONTyped,
    PerformerMediaToJSON,
    PerformerMediaToJSONTyped,
} from './PerformerMedia';
import type { PrimaryCategoryEnum } from './PrimaryCategoryEnum';
import {
    PrimaryCategoryEnumFromJSON,
    PrimaryCategoryEnumFromJSONTyped,
    PrimaryCategoryEnumToJSON,
    PrimaryCategoryEnumToJSONTyped,
} from './PrimaryCategoryEnum';

/**
 * Serializer for Performer model with comprehensive details.
 * @export
 * @interface Performer
 */
export interface Performer {
    /**
     * 
     * @type {string}
     * @memberof Performer
     */
    readonly id: string;
    /**
     * Artist or band name (must be unique)
     * @type {string}
     * @memberof Performer
     */
    performerName: string;
    /**
     * Artist/band biography and description
     * @type {string}
     * @memberof Performer
     */
    bio?: string;
    /**
     * 
     * @type {PrimaryCategoryEnum}
     * @memberof Performer
     */
    primaryCategory?: PrimaryCategoryEnum;
    /**
     * Searchable tags (e.g., "touring", "local", "established")
     * @type {Array<string>}
     * @memberof Performer
     */
    tags?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof Performer
     */
    website?: string;
    /**
     * Social media links: facebook, instagram, twitter, spotify, etc.
     * @type {any}
     * @memberof Performer
     */
    socialMedia?: any | null;
    /**
     * Performer's hometown (city, state/region, country)
     * @type {any}
     * @memberof Performer
     */
    hometown?: any | null;
    /**
     * Stage plot, equipment, and technical requirements
     * @type {string}
     * @memberof Performer
     */
    technicalRider?: string;
    /**
     * Dressing room, catering, and hospitality requirements
     * @type {string}
     * @memberof Performer
     */
    hospitalityRider?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Performer
     */
    readonly hasBio: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Performer
     */
    readonly hasTechnicalRider: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Performer
     */
    readonly hasHospitalityRider: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Performer
     */
    readonly hasMedia: boolean;
    /**
     * 
     * @type {string}
     * @memberof Performer
     */
    readonly profileCompletion: string;
    /**
     * 
     * @type {string}
     * @memberof Performer
     */
    readonly bookingCount: string;
    /**
     * 
     * @type {boolean}
     * @memberof Performer
     */
    isActive?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Performer
     */
    createdBy?: number | null;
    /**
     * 
     * @type {string}
     * @memberof Performer
     */
    readonly createdByName: string;
    /**
     * 
     * @type {Array<PerformerMedia>}
     * @memberof Performer
     */
    readonly media: Array<PerformerMedia>;
    /**
     * 
     * @type {Date}
     * @memberof Performer
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof Performer
     */
    readonly updatedAt: Date;
}



/**
 * Check if a given object implements the Performer interface.
 */
export function instanceOfPerformer(value: object): value is Performer {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('performerName' in value) || value['performerName'] === undefined) return false;
    if (!('hasBio' in value) || value['hasBio'] === undefined) return false;
    if (!('hasTechnicalRider' in value) || value['hasTechnicalRider'] === undefined) return false;
    if (!('hasHospitalityRider' in value) || value['hasHospitalityRider'] === undefined) return false;
    if (!('hasMedia' in value) || value['hasMedia'] === undefined) return false;
    if (!('profileCompletion' in value) || value['profileCompletion'] === undefined) return false;
    if (!('bookingCount' in value) || value['bookingCount'] === undefined) return false;
    if (!('createdByName' in value) || value['createdByName'] === undefined) return false;
    if (!('media' in value) || value['media'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function PerformerFromJSON(json: any): Performer {
    return PerformerFromJSONTyped(json, false);
}

export function PerformerFromJSONTyped(json: any, ignoreDiscriminator: boolean): Performer {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'performerName': json['performer_name'],
        'bio': json['bio'] == null ? undefined : json['bio'],
        'primaryCategory': json['primary_category'] == null ? undefined : PrimaryCategoryEnumFromJSON(json['primary_category']),
        'tags': json['tags'] == null ? undefined : json['tags'],
        'website': json['website'] == null ? undefined : json['website'],
        'socialMedia': json['social_media'] == null ? undefined : json['social_media'],
        'hometown': json['hometown'] == null ? undefined : json['hometown'],
        'technicalRider': json['technical_rider'] == null ? undefined : json['technical_rider'],
        'hospitalityRider': json['hospitality_rider'] == null ? undefined : json['hospitality_rider'],
        'hasBio': json['has_bio'],
        'hasTechnicalRider': json['has_technical_rider'],
        'hasHospitalityRider': json['has_hospitality_rider'],
        'hasMedia': json['has_media'],
        'profileCompletion': json['profile_completion'],
        'bookingCount': json['booking_count'],
        'isActive': json['is_active'] == null ? undefined : json['is_active'],
        'createdBy': json['created_by'] == null ? undefined : json['created_by'],
        'createdByName': json['created_by_name'],
        'media': ((json['media'] as Array<any>).map(PerformerMediaFromJSON)),
        'createdAt': (new Date(json['created_at'])),
        'updatedAt': (new Date(json['updated_at'])),
    };
}

  export function PerformerToJSON(json: any): Performer {
      return PerformerToJSONTyped(json, false);
  }

  export function PerformerToJSONTyped(value?: Omit<Performer, 'id'|'has_bio'|'has_technical_rider'|'has_hospitality_rider'|'has_media'|'profile_completion'|'booking_count'|'created_by_name'|'media'|'created_at'|'updated_at'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'performer_name': value['performerName'],
        'bio': value['bio'],
        'primary_category': PrimaryCategoryEnumToJSON(value['primaryCategory']),
        'tags': value['tags'],
        'website': value['website'],
        'social_media': value['socialMedia'],
        'hometown': value['hometown'],
        'technical_rider': value['technicalRider'],
        'hospitality_rider': value['hospitalityRider'],
        'is_active': value['isActive'],
        'created_by': value['createdBy'],
    };
}

